/* ============================================================================
   SOLAGO KONFIGURATOR – konfigurator-variants.js
   Gehört zu snippets/konfigurator-variants.liquid
   ============================================================================ */
(function () {
  'use strict';

  if (window.__kvInit) return;
  window.__kvInit = true;

  /* --------------------------------------------------------------------
     1) Gruppen auf-/zuklappen
  -------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-kv-toggle]');
    if (!toggle) return;
    if (e.target.closest('[data-kv-popup]')) return; // Info-Icon klick nicht togglen

    var group = toggle.closest('[data-kv-group]');
    if (!group) return;

    var isOpen = group.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* --------------------------------------------------------------------
     2) Info-Popups (dialog)
  -------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-kv-popup]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var dialog = document.getElementById(trigger.getAttribute('data-kv-popup'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    var closeBtn = e.target.closest('[data-kv-popup-close]');
    if (closeBtn) {
      var d = closeBtn.closest('dialog');
      if (d) d.close();
    }
  });

  // Klick auf den Backdrop schließt das Popup
  document.querySelectorAll('dialog.kv-popup').forEach(function (dialog) {
    dialog.addEventListener('click', function (e) {
      var wrapper = dialog.querySelector('.kv-popup__wrapper');
      if (wrapper && !wrapper.contains(e.target)) dialog.close();
    });
  });

  /* --------------------------------------------------------------------
     3) Speicher-Vorschaubild mit Auswahl synchronisieren
  -------------------------------------------------------------------- */
  function bindPreviewBoxes() {
    document.querySelectorAll('[data-kv-preview-box]').forEach(function (box) {
      if (box.dataset.kvBound) return;
      box.dataset.kvBound = '1';

      var group = box.closest('[data-kv-group]');
      if (!group) return;

      var previews = box.querySelectorAll('[data-kv-preview]');
      var radios = group.querySelectorAll('.kv-pill-list input[type="radio"]');

      function sync(value) {
        previews.forEach(function (p) {
          p.hidden = p.getAttribute('data-kv-preview') !== value;
        });
      }

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.checked) sync(r.value);
        });
      });
    });
  }

  if (document.readyState !== 'loading') bindPreviewBoxes();
  else document.addEventListener('DOMContentLoaded', bindPreviewBoxes);

  /* --------------------------------------------------------------------
     4) Produktwechsel-Links ("Ohne Speicher" <-> Bundle):
        Scrollposition merken, Fortschrittsbalken zeigen, navigieren.
  -------------------------------------------------------------------- */
  var SCROLL_KEY = 'kvScrollRestore';

  // Scrollposition nach dem Produktwechsel wiederherstellen
  (function restoreScroll() {
    try {
      try { history.scrollRestoration = 'manual'; } catch (_) {}
      var raw = sessionStorage.getItem(SCROLL_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.y !== 'number') {
        sessionStorage.removeItem(SCROLL_KEY);
        return;
      }
      var targetY = parsed.y | 0;
      var html = document.documentElement;
      var prevBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      var tries = 0;

      function tick() {
        tries++;
        var doc = document.scrollingElement || document.documentElement;
        var maxY = Math.max(0, (doc.scrollHeight - window.innerHeight) | 0);
        var y = Math.min(maxY, targetY);
        window.scrollTo(0, y);
        if (Math.abs(window.scrollY - y) <= 2 || tries >= 60) {
          sessionStorage.removeItem(SCROLL_KEY);
          html.style.scrollBehavior = prevBehavior || '';
          return;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      if (document.readyState !== 'complete') {
        window.addEventListener('load', function () { requestAnimationFrame(tick); }, { once: true });
      }
    } catch (e) {
      try { sessionStorage.removeItem(SCROLL_KEY); } catch (_) {}
    }
  })();

  var overlay = null;
  var fill = null;

  function showProgress() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'kvProgressOverlay';
      overlay.innerHTML = '<div class="kv-progress"><div class="kv-progress__fill"></div></div>';
      document.body.appendChild(overlay);
      fill = overlay.querySelector('.kv-progress__fill');
    }
    overlay.classList.add('is-active');
    requestAnimationFrame(function () {
      if (fill) fill.style.width = '85%';
    });
  }

  window.addEventListener('pageshow', function () {
    if (overlay) overlay.classList.remove('is-active');
    if (fill) fill.style.width = '0';
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-kv-product-link]');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1 || link.target === '_blank') return;

    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;

    e.preventDefault();
    try {
      sessionStorage.setItem(SCROLL_KEY, JSON.stringify({ y: window.scrollY || 0 }));
    } catch (_) {}
    showProgress();
    setTimeout(function () { window.location.assign(url.toString()); }, 40);
  });

})();
